const groupActionTypes = {

    START_GET_GROUP: 'START_GET_GROUP',
    GET_GROUPS_SUCCESS: 'GET_GROUPS_SUCCESS',
    GET_GROUPS_FAILURE: 'GET_GROUPS_FAILURE',

    START_ADD_GROUP: 'START_ADD_GROUP',
    ADD_GROUP_SUCCESS: 'ADD_GROUP_SUCCESS',
    ADD_GROUP_FAILURE: 'ADD_GROUP_FAILURE',

    START_UPDATE_GROUP: 'START_UPDATE_GROUP',
    UPDATE_GROUP_SUCCESS: 'UPDATE_GROUP_SUCCESS',
    UPDATE_GROUP_FAILURE: 'UPDATE_GROUP_FAILURE',

    START_ATTACH_CHARGER_GROUP: 'START_ATTACH_CHARGER_GROUP',
    ATTACH_CHARGER_GROUP_SUCCESS: 'ATTACH_CHARGER_GROUP_SUCCESS',
    ATTACH_CHARGER_GROUP_FAILURE: 'ATTACH_CHARGER_GROUP_FAILURE',

    START_DELETE_GROUP: 'START_DELETE_GROUP',
    DELETE_GROUP_SUCCESS: 'DELETE_GROUP_SUCCESS',
    DELETE_GROUP_FAILURE: 'DELETE_GROUP_FAILURE',

    SELECT_GROUP: 'SELECT_GROUP',
    UNSELECT_GROUP: 'UNSELECT_GROUP',
    UPDATE_TRANSACTION_DATA: 'UPDATE_TRANSACTION_DATA',
    RESET: 'RESET',

    RESET_STATE_INFO: 'RESET_STATE_INFO',
};

export default groupActionTypes;